import { Link } from "react-router-dom";
import { categories } from "@/mocks/movies";

export default function CategorySection() {
  return (
    <section className="max-w-[1400px] mx-auto px-4 md:px-6 py-14 md:py-20">
      <div className="text-center mb-10">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3">影视分类</h2>
        <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
          涵盖多种类型，满足你的观影需求。无论你喜欢什么类型，这里都有你想要的精彩内容。
        </p>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
        {categories.map((cat) => (
          <Link
            key={cat.id}
            to={`/category/${cat.slug}`}
            className="group relative rounded-lg overflow-hidden aspect-[4/3] bg-background-100 cursor-pointer"
          >
            <div className="absolute inset-0 bg-gradient-to-br from-accent-500/10 to-accent-500/5 group-hover:from-accent-500/20 group-hover:to-accent-500/10 transition-all duration-300"></div>
            <div className="absolute inset-0 flex flex-col items-center justify-center p-4 text-center">
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center mb-3 rounded-full bg-accent-100/80 text-accent-600 group-hover:scale-110 transition-transform duration-300">
                <i className={`${getCategoryIcon(cat.slug)} text-xl md:text-2xl`}></i>
              </div>
              <h3 className="text-sm md:text-base font-semibold text-foreground-950 group-hover:text-accent-600 transition-colors duration-200 whitespace-nowrap">
                {cat.name}
              </h3>
              <p className="text-xs text-foreground-500 mt-1 line-clamp-2">{cat.description}</p>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}

function getCategoryIcon(slug: string): string {
  const icons: Record<string, string> = {
    action: "ri-sword-line",
    comedy: "ri-emotion-laugh-line",
    romance: "ri-heart-line",
    "sci-fi": "ri-rocket-line",
    horror: "ri-ghost-line",
    animation: "ri-palette-line",
    drama: "ri-emotion-line",
    "tv-series": "ri-tv-line",
  };
  return icons[slug] || "ri-movie-2-line";
}